import Swiper, { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { setNews } from "../../common/functions/setNews.es6";
import { trimNews } from "../../common/functions/trimNews.es6";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class News {
    constructor() {
        this.init();
    }

    init() {
        this.setSwiper();
        setNews(5, 3, "isTopMode");
        trimNews();
        this.onScroll();
    }

    setSwiper() {
        const swiper = new Swiper(".swiper", {
            modules: [Navigation],
            loop: true,
            slidesPerView: 2,
            spaceBetween: 20,
            centeredSlides: true,

            breakpoints: {
                835: {
                    slidesPerView: 3,
                    centeredSlides: false,
                },
            },

            // Navigation arrows
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        //ひとつver
        // const swiper = new Swiper(".swiper", {
        //     slidesPerView: 1,
        // });
    }

    onScroll() {
        const revealElm = [...document.querySelectorAll(".js-newsscrollreveal")];

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 85%",
                //markers: true,
                onEnter: () => {
                    el.classList.add("-reveal");
                },
            });
        });
    }
}
